import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import { secondsToHHMM } from "../../../../Utilitie";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import NoDataFound from "../../../../Extra/NoDataFound";

const CountDayWise = ({ data, date }) => {
  /////////////////////////////////////

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const tableRef = useRef();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [finalData, setFinalData] = useState([]);
  const [top3, setTop3] = useState([]);

  useEffect(() => {
    const result = Object.values(
      (data || []).reduce((acc, item) => {
        const date = item.A_DATE;
        acc[date] = acc[date] || { date, count: 0 };
        acc[date].count++;
        return acc;
      }, {}),
    );

    const top3 = [...result].sort((a, b) => b.count - a.count).slice(0, 3);

    setTop3(top3);

    setFinalData(result);
  }, [data]);
  console.log(top3);
  /////////////////////////////////////

  return (
    <div>
      {" "}
      <div className="papaDiv">
        {" "}
        <h5 className="bg-dark text-white text-center p-2">Long Haul</h5>
        <div
          className="table-responsive table-wrapper"
          style={{ maxHeight: "650px" }}
        >
          {loading && <Loading />}
          {/* <table
            ref={tableRef}
            className="table table-bordered table-striped mb-4 papaDiv"
            style={{ fontSize: "11px" }}
          >
            <thead className="table-dark">
              <tr>
                {finalData?.map((row, index) => (
                  <th key={index}>{row.date.slice(0, 10)}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              <tr>
                {finalData?.map((row, index) => (
                  <td key={index}>{row.count}</td>
                ))}
              </tr>
            </tbody>
          </table> */}

          {/* ///////////// */}
          <table
            ref={tableRef}
            className="table table-bordered table-striped mb-4 papaDiv"
            style={{ fontSize: "11px" }}
          >
            <thead
              className="table-dark text-center align-middle    sticky-top"
              style={{ zIndex: 1 }}
            >
              <tr>
                <th>SR NO. </th>
                <th>DATE</th>
                <th>COUNT</th>
              </tr>
            </thead>
            <tbody>
              {finalData && finalData.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No data available
                  </td>
                </tr>
              ) : (
                finalData &&
                finalData.map((row, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        backgroundColor: top3.some((o) => o.count === row.count)
                          ? "#d5cce7"
                          : "",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        backgroundColor: top3.some((o) => o.count === row.count)
                          ? "#d5cce7"
                          : "",
                      }}
                    >
                      {row.date.slice(0, 10)}
                    </td>

                    <td
                      style={{
                        backgroundColor: top3.some((o) => o.count === row.count)
                          ? "#d5cce7"
                          : "",
                      }}
                    >
                      {row.count}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {/* //////////////////// */}
          {data?.length === 0 && <NoDataFound />}
        </div>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`  Long Haul Hand Over  Report - ${date.start}-${date.end}
        
            `}
      />
    </div>
  );
};

export default CountDayWise;
